// Короткие подписи месяцев для тиков графика (EnpsMonthlyTrendChart) — полные названия
// ("Январь", как в EnpsDashboardPage.vue's monthOptions) слишком широкие для оси с 12 точками.
export default ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
